export default "__VITE_ASSET__09fb1d53__"